import PropTypes from 'prop-types';
import Center from './Center';

/**
 * Error component for use for developer errors in components
 */
import { jsx as _jsx } from "react/jsx-runtime";
var Error = function Error(_ref) {
  var children = _ref.children,
    centered = _ref.centered;
  var message = /*#__PURE__*/_jsx("div", {
    style: {
      background: '#f00',
      padding: '0 .5rem'
    },
    children: children
  });
  if (centered) {
    return /*#__PURE__*/_jsx(Center, {
      horizontally: true,
      vertically: true,
      children: message
    });
  }
  return message;
};
Error.propTypes = {
  children: PropTypes.node,
  centered: PropTypes.bool
};
export default Error;